import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "column-wide-add" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M1.66699 13H1.16699V13.5H1.66699V13ZM1.66699 3V2.5H1.16699V3H1.66699ZM8.00033 13V13.5H8.50033V13H8.00033ZM14.3337 3H14.8337V2.5L14.3337 2.5V3ZM13.8337 7.66667V8.16667H14.8337V7.66667H13.8337ZM8.00033 3V2.5V3ZM13.5003 9.66667V9.16667H12.5003V9.66667H13.5003ZM12.5003 13.6667V14.1667H13.5003V13.6667H12.5003ZM11.0003 11.1667H10.5003V12.1667H11.0003V11.1667ZM15.0003 12.1667H15.5003V11.1667H15.0003V12.1667ZM2.16699 13V3H1.16699V13H2.16699ZM8.00033 12.5H1.66699V13.5H8.00033V12.5ZM13.8337 3V7.66667H14.8337V3H13.8337ZM1.66699 3.5H8.00033V2.5H1.66699V3.5ZM8.00033 3.5L14.3337 3.5V2.5L8.00033 2.5V3.5ZM8.50033 13V3H7.50033V13H8.50033ZM12.5003 9.66667V11.6667H13.5003V9.66667H12.5003ZM12.5003 11.6667V13.6667H13.5003V11.6667H12.5003ZM11.0003 12.1667H13.0003V11.1667H11.0003V12.1667ZM13.0003 12.1667H15.0003V11.1667H13.0003V12.1667Z",
        fill: "#7F7F83"
      })
    ], -1)
  ])))
}
export default { render: render }